
 export const secondsToHour = (seconds)=>{
  //  console.log(seconds)
    var date = new Date(null);
    date.setMilliseconds(seconds);
    return date.toISOString().substr(11, 8);
 }